module.exports = __webpack_public_path__ + "img/ecuador.d4dcf221.svg";